<template>
    <div class="statistic-dashboard-balance">
        <div class="statisitc-dashboard-filter">
            <el-date-picker
                v-model="selectedDateTime"
                type="datetime"
                align="right"
                placeholder="Select Date & Time"
                ref="picker"
                @change="onDateTimeChanged"
            ></el-date-picker>
            <el-button type="primary" class="btn-export" @click="onExportClick">Export CSV</el-button>
        </div>
        <el-table
            :data="table"
            style="width: 100%"
            size="mini"
            stripe
            v-loading="processing"
        >
            <el-table-column prop="id" label="ID" width="50" fixed></el-table-column>
            <el-table-column prop="display_name" label="Name" width="180" fixed></el-table-column>
            <el-table-column prop="email" label="Email" width="200" fixed></el-table-column>
            <el-table-column prop="identification_type" label="ID Type" width="100"></el-table-column>
            <el-table-column :label="field" v-for="(field) in fields" :key="field" header-align="right" align="right" width="150">
                <template slot-scope="scope"><span v-if="scope.row[field]!=null">{{scope.row[field]}}</span></template>
            </el-table-column>
            <!-- <el-table-column prop="fund_lock" label="Lock" ></el-table-column> -->
            <el-table-column label="Updated" width="150">
                <template slot-scope="scope">{{scope.row.updated}}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import moment from "moment";
const { parseAsync } = require('json2csv');

export default {
    name: "StatisticDashboardBalance",
    components: {},
    data() {
        return {
            selectedDateTime: new Date(),
            daterange: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "1 week",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "1 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "3 month",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            tableData: [],
            processing: false
        };
    },
    mounted() {
        this.loadData();
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms
        }),
        endDate() {
            if(this.selectedDateTime) {
                return moment(this.selectedDateTime).utc().format('YYYY-MM-DD HH:mm:ss');
            }
            return null
        },
        fields() {
            if(this.tableData.length > 0) {
                return Object.keys(this.tableData[0]).filter(k => {
                    return k != "id"
                    && k != "display_name"
                    && k != "email"
                    && k != "identification_type"
                    && k != "created"
                    && k != "updated"
                    && k != "auth_id"
                });
            }
            return [];
        },
        table() {
            return this.tableData.map(d =>{
                d.updated = moment(d.updated).format('Do MMM YYYY HH:mm:ss');
                return d;
            });
        }
    },
    watch: {
        daterange() {
            this.loadData();
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        moment,
        onDateTimeChanged() {
            this.loadData();
        },
        loadData() {
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = `statistic/balance`;
            let params = {};
            let where = ""
            if(ctrl.endDate) {
                // if(where.length > 0) { where += ` AND ` }
                where += ` BLC.updated <= '${ctrl.endDate}' `
            }
            params = { where }
            ctrl.request({
                method: "GET",
                endpoint,
                params
            })
                .then(({ data = {} }) => {
                    ctrl.tableData = data;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "STATISTIC_ERROR",
                        message: "Load Statistical Data Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
        onExportClick() {
            // var csv = this.JSON2CSV(this.tableData);
            parseAsync(this.tableData, {fields: [
                "id",
                "display_name",
                "email",
                "identification_type",
                "updated",
                ...this.fields
                ]})
            .then(csv => {
                var hiddenElement = document.createElement('a');  
                hiddenElement.href = 'data:text/csv;charset=unicode,' + encodeURI(csv);  
                hiddenElement.target = '_blank';  
                
                //provide the name for the CSV file to be downloaded  
                hiddenElement.download = 'export.csv';  
                hiddenElement.click();  
            });
        },

    }
};
</script>
<style scoped>
</style>
<style>
.btn-export {
    margin-left: 16px;
}
</style>